import { GraphicalDashboardCard } from "../../components/dashboard/GraphicalDashboardCard";
import React from "react";
import { DashboardData } from "../../types/dashboardData";
import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";
import { useCustomTranslation } from "../../provider/useCustomTranslation";

export function EventsCard(props: { data: DashboardData }) {
  const { data } = props;
  const { t } = useCustomTranslation();
  const series = [
    data.events.draftEvents,
    data.events.upcomingEvents,
    data.events.liveEvents,
  ];
  const options: ApexOptions = {
    chart: {},
    dataLabels: {
      formatter(value, { seriesIndex, dataPointIndex, w }): string | number {
        return series[seriesIndex].toString();
      },
    },
    series: series,
    labels: [
      t("pages.dashboard.eventStatus.draft"),
      t("pages.dashboard.eventStatus.upcoming"),
      t("pages.dashboard.eventStatus.live"),
    ],
    colors: ["#70707050", "#FD6A1C", "#4832BB"],
  };

  const totalEvents = series.reduce((acc, val) => acc + val, 0);

  return (
    <GraphicalDashboardCard
      gridProps={{ xs: 12, md: 6 }}
      title={t("common.events")}
      resource={"events"}
    >
      {totalEvents > 0 ? (
        <Chart
          options={options}
          series={options.series}
          type="donut"
          width={350}
        />
      ) : (
        t("pages.dashboard.noData")
      )}
    </GraphicalDashboardCard>
  );
}
